"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgNotificationsOff = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_NOTIFICATIONS-OFF", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M10.826 4.195c.094.227.185.47.274.73l1.764-1.008c-.062-.167-.125-.33-.19-.487-.404-.978-.923-1.856-1.704-2.483C10.164.3 9.18 0 8 0 6.82 0 5.836.3 5.03.947c-.78.627-1.3 1.506-1.704 2.483-.404.976-.732 2.147-1.073 3.43l-.173.65c-.25.944-.518 1.959-.841 3.05l2.475-1.414c.106-.392.206-.77.302-1.133l.169-.638c.346-1.296.643-2.344.989-3.18.345-.835.702-1.362 1.108-1.689C6.664 2.2 7.18 2 8 2s1.336.2 1.718.506c.406.327.762.854 1.108 1.689ZM.132 13.496a1 1 0 0 0 1.364.372l1.885-1.077C4.34 12.904 5.799 13 8 13c2.53 0 4.08-.126 5.016-.26.47-.067.793-.137 1.013-.197a3.217 3.217 0 0 0 .353-.118l.013-.006.022-.01.016-.008.007-.003.004-.002h.001l.002-.002a1 1 0 0 0 .509-1.188c-.412-1.34-.737-2.568-1.036-3.695v-.002l-.17-.643 1.746-.998a1 1 0 1 0-.992-1.736l-14 8a1 1 0 0 0-.372 1.364Zm11.82-5.603.032.12c.223.84.466 1.76.752 2.747h-.002C11.92 10.876 10.47 11 8 11c-.532 0-1.016-.006-1.457-.016l5.41-3.09ZM10.535 13.94a55.36 55.36 0 0 1-2.503.059h-.079a54.44 54.44 0 0 1-2.503-.06c.069.375.224.721.445 1.019a2.603 2.603 0 0 0 2.176 1.04 2.603 2.603 0 0 0 2.018-1.04c.221-.297.377-.643.446-1.018Z" }))); };
exports.default = SvgNotificationsOff;
